<template>
  <div>
    <div class="title">如何评价商品？</div>
    <div class="content-info">
      <p class="txt1">订单签收后，订单页面右下角点击“立即评价”按钮，即可对商品、服务进行评价。</p>
      <ul>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/f2bba0aacc4e2b2608b7acd88cd511be.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/eb0bdd246b8bb8b83732963a04519c2a.png" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
